function noopFn() {}
const noop = noopFn as any;
export { noop };
